import React, { useState, useContext, useEffect, useCallback } from "react";
import MovePlannerContext from "../../context/move_planner/movePlanner";
import { activeCityListAPI } from "../../adapters/estimate/estimateAdapters";
import { useSelector, useDispatch } from "react-redux";

import { thunkLoadMoveInfoFromSession } from "../../redux/reducers/storage_moveinfo/moveInfoReducer";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import ServiceCitySelect from "../getEstimate/ServiceCitySelect";
import AutoComplete from "../common/AutoComplete";
import { StorageMoveInfoSkeleton } from "../skeleton/storage_services/StorageMoveInfoSkeleton";
function GetEstimate(props) {
  const context = useContext(MovePlannerContext);
  const moveInfoState = useSelector((state) => state.storageMoveInfo);
  const selectedCity = moveInfoState.selectCity;
  const pickupAddress = moveInfoState.pickupAddress;
  const pickupDate = moveInfoState.pickupDate;
  const [elevatorStatus, setElevatorStatus] = useState(
    moveInfoState.serviceLiftAvailable
  );
  const isRequired = (value) => (value === "" ? false : true);
  const {
    register,
    errors,
    handleSubmit: moveInfoSubmit,
    control,
    setValue,
    // getValues,
    clearErrors,
  } = context.estimateForm.useStorageMoveInfoForm;

  const {
    // moveType,
    // setMoveType,
    isCityListLoading,
    setIsCityListFetching,
    cityList,
    setCityList,
    hasError,
    setHasError,
    onSubmit,
  } = props.state;

  // global state access.
  const dispatch = useDispatch();

  const loadFromSession = useCallback(() => {
    if (
      moveInfoState.hasLoadedFromSession === false &&
      sessionStorage.getItem("storage_moveinfo") !== null
    ) {
      const data = sessionStorage.getItem("storage_moveinfo");
      dispatch(thunkLoadMoveInfoFromSession({ moveInfo: data }));
    }
  }, [dispatch, moveInfoState.hasLoadedFromSession]);

  // const changeMoveType = useCallback(
  //   (type) => {
  //     setMoveType(type);
  //   },
  //   [setMoveType]
  // );

  useEffect(() => {
    if (cityList !== null) {
      return;
    }
    setIsCityListFetching(true);
    const getCityList = async function (data) {
      try {
        const response = await activeCityListAPI();
        //load move info state from local stored session.
        loadFromSession();
        setCityList(response.data.ServiceCity);
        setIsCityListFetching(false);

        return response;
      } catch (error) {
        setIsCityListFetching(false);
        setHasError(true);
        // TODO : create a error display components, handle error rendering
        console.error(error);
      }
    };
    getCityList();
    // eslint-disable-next-line 
  }, [loadFromSession, setIsCityListFetching, setCityList, setHasError]);

  // useEffect(() => {
  //   changeMoveType(moveInfoState.moveType);
  // }, [moveInfoState.moveType, changeMoveType]);

  const JSX = (
    <>
      <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5">
        <div className="row">
          <div className="col-12 move-details-section">
            <form
              id="makeEstimateForm"
              autoComplete="off"
              className="col-12"
              noValidate={true}
              method="POST"
              onSubmit={moveInfoSubmit(onSubmit)}
            >
              <div className="move-details-container">
                <div className="move-type">
                  {/* <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="withinCity"
                      ref={register}
                      onChange={(e) => {
                        changeMoveType("Within City");
                      }}
                      name="city_type"
                      value="Within City"
                      checked={moveType === "Within City" ? true : false}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="withinCity"
                    >
                      HouseHold Storage
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="interCity"
                      onChange={(e) => {
                        changeMoveType("Inter City");
                      }}
                      ref={register}
                      name="city_type"
                      value="Inter City"
                      checked={moveType === "Inter City" ? true : false}
                    />
                    <label className="custom-control-label" htmlFor="interCity">
                      Business Storage
                    </label>
                  </div> */}
                </div>
                {isCityListLoading === true && (
                  <>
                    <StorageMoveInfoSkeleton />
                  </>
                )}
                {hasError === false &&
                  isCityListLoading === false &&
                  cityList.length > 0 && (
                    <div className="move-info">
                      <div className="form-group">
                        <label className="form-label">
                          {" "}
                          Select your city <span className="manditory">*</span>
                        </label>
                        <ServiceCitySelect
                          name="select_city"
                          className="form-control"
                          id="select_city"
                          innerRef={register({
                            required: true,
                          })}
                          onChange={() => {
                            setValue("pickup_address", "");
                            // setValue("to_area_within", "");
                            clearErrors(["pickup_address"]);
                          }}
                          cityList={cityList}
                          defaultValue={selectedCity}
                        />
                        <div className="select_city-error error-text">
                          {errors.select_city &&
                            errors.select_city.type === "required" && (
                              <> This field is required </>
                            )}
                        </div>
                      </div>

                      <div className="form-group position-relative">
                        <label className="form-label">
                          Enter Pickup Address{" "}
                          <span className="manditory">*</span>
                        </label>

                        <AutoComplete
                          name="pickup_address"
                          placeholder="Select Building or Nearest Landmark"
                          id="pickup_address"
                          cityType={"within city"}
                          className="form-control"
                          innerRef={register({
                            validate: {
                              isRequired: isRequired,
                              isFromAndToSame: () => { },
                              isCitySelected: () => { },
                            },
                          })}
                          defaultValue={pickupAddress}
                          changeHandler={(value) => {
                            setValue("pickup_address", value);
                          }}
                          AutoCompleteID="pickupaddressAutoComplete"
                        />
                        <div className="from_area_within-error error-text">
                          {errors.pickup_address &&
                            errors.pickup_address.type === "isRequired" && (
                              <> This field is required </>
                            )}
                          {errors.pickup_address &&
                            errors.pickup_address.type ===
                            "isFromAndToSame" && (
                              <> From and To cannot be same </>
                            )}
                          {errors.pickup_address &&
                            errors.pickup_address.type === "isCitySelected" && (
                              <> Please select a city first.</>
                            )}
                          {errors.pickup_address &&
                            errors.pickup_address.type ===
                            "isWithinCityBounds" && (
                              <> Location is not within city bounds </>
                            )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-6">
                          <div className="form-group">
                            <label className="form-label mb-2">
                              Service Lift Available?{" "}
                            </label>
                            <></>
                            <div className="house-detials-container">
                              <div
                                className="btn-group btn-group-toggle"
                                data-toggle="buttons"
                              >
                                <label
                                  className={
                                    "btn btn-primary btn-sm yes-btn" +
                                    (elevatorStatus === "Yes" ? " active" : "")
                                  }
                                >
                                  <input
                                    type="radio"
                                    name="elevator_availability"
                                    value="Yes"
                                    autoComplete="off"
                                    ref={register}
                                    onChange={(e) => {
                                      setElevatorStatus("Yes");
                                    }}
                                    checked={
                                      elevatorStatus === "Yes" ? true : false
                                    }
                                  />
                                  Yes
                                </label>
                                <label
                                  className={
                                    "btn btn-primary btn-sm no-btn" +
                                    (elevatorStatus === "No" ? " active" : "")
                                  }
                                >
                                  <input
                                    type="radio"
                                    name="elevator_availability"
                                    value="No"
                                    ref={register}
                                    autoComplete="off"
                                    onChange={(e) => {
                                      setElevatorStatus("No");
                                    }}
                                    checked={
                                      elevatorStatus === "No" ? true : false
                                    }
                                  />
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {elevatorStatus === "No" && (
                          <div className="col-sm-12 col-md-6">
                            <div className={`form-group`}>
                              <label className="form-label mb-2">
                                Floor No <span className="manditory">*</span>
                              </label>
                              <input
                                class="form-control"
                                type="text"
                                name="floor_no"
                                id="floor_no"
                                defaultValue={moveInfoState.floorNo}
                                ref={register({
                                  validate: {
                                    isRequired: isRequired,
                                    onlyNumber: (value) =>
                                      /^[0-9]*$/.test(value) ||
                                      "Please enter only numbers",
                                    maxInput: (value) =>
                                      parseInt(value) <= 300 ||
                                      "Maximum input allowed is 300",
                                  },
                                })}
                                placeholder="Ex: 4"
                              />
                              <div className="from_area_within-error error-text">
                                {errors.floor_no &&
                                  errors.floor_no.type === "isRequired" && (
                                    <> This field is required </>
                                  )}
                                {errors.floor_no !== undefined
                                  ? errors.floor_no.message
                                  : ""}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          Expected Days of storage{" "}
                          <span className="manditory">*</span>
                        </label>
                        <input
                          class="form-control"
                          type="text"
                          name="days_of_storage"
                          id="days_of_storage"
                          defaultValue={moveInfoState.daysOfStorage}
                          ref={register({
                            validate: {
                              isRequired: isRequired,
                              onlyNumber: (value) =>
                                /^[0-9]*$/.test(value) ||
                                "Please enter only numbers",
                              minInput: (value) => {
                                return (
                                  parseInt(value) > 0 ||
                                  "Minimum input required is 1"
                                );
                              },
                              maxInput: (value) =>
                                parseInt(value) <= 9999 ||
                                "Maximum input allowed is 9999",
                            },
                          })}
                          placeholder="Ex: 365"
                        />
                        <div className="from_area_within-error error-text">
                          {errors.days_of_storage &&
                            errors.days_of_storage.type === "isRequired" && (
                              <> This field is required </>
                            )}
                          {errors.days_of_storage !== undefined
                            ? errors.days_of_storage.message
                            : ""}
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="form-label">
                          Tenative Pickup Date{" "}
                          <span className="manditory">*</span>
                        </label>
                        <div className="d-block">
                          <Controller
                            control={control}
                            name="pickup_date"
                            rules={{
                              validate: {
                                isRequired: isRequired,
                                // isFromAndToSame: isFromAndToSame,
                              },
                            }}
                            defaultValue={pickupDate}
                            render={(props) => (
                              <DatePicker
                                className="form-control datetimepicker"
                                showTimeSelect
                                placeholderText="Pickup date"
                                onChange={(e) => props.onChange(e)}
                                selected={props.value}
                                dateFormat="dd/MM/yyyy h:mm aa"
                                minDate={new Date()}
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                timeCaption="Time"
                                showDisabledMonthNavigation
                              />
                            )}
                          />
                        </div>
                        <div className="from_area_within-error error-text">
                          {errors.pickup_date &&
                            errors.pickup_date.type === "isRequired" && (
                              <> This field is required </>
                            )}
                        </div>
                      </div>
                      <div className="form-group border-0 submit-container">
                        {moveInfoState.isMoveInfoFormSubmitting === false && (
                          <input
                            type="submit"
                            className="btn btn-primary w-100 mt-4"
                            value="Get Free Quote"
                          />
                        )}
                        {moveInfoState.isMoveInfoFormSubmitting === true && (
                          <button
                            type="button"
                            className="btn btn-primary loading-btn w-100 mt-4"
                          >
                            <div className="spinner-border" role="status">
                              <span className="sr-only"></span>
                              {"  "}
                            </div>{" "}
                            Submitting...
                          </button>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </form>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}

export default GetEstimate;
